<template>
  <div>
    <el-row type="flex" align="middle" id="header-container">
      <el-col :span="4">
        <div id="header-img-container">
          <img alt="DOE Logo" src="../../assets/doe-logo.jpeg" id="header-img">
        </div>
        <div class="header-text">Hawaii State</div>
        <div class="header-text">Department of Education</div>
      </el-col>
      <el-col :span="8">
        <div id="scrolling-message">
         <marquee>{{announcement}}</marquee>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="header-right">
          <el-menu :router="true"
                   mode="horizontal"
                   :default-active="defaultActive">
            <el-menu-item :class="$mq" index="/organization-summary"
                          :route="{path: '/organization-summary'}">
              Organization Summary
            </el-menu-item>
            <el-menu-item :class="$mq" index="/program-summary"
                          :route="{path: '/program-summary'}">
              Program ID Summary
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../../utils/api';
import * as Paths from '../../constants/paths';

export default {
  name: 'AppHeader',
  computed: {
    defaultActive() {
      return this.$route.path;
    },
  },
  data() {
    return {
      announcementOptions: [],
      announcement: '',
    };
  },
  methods: {
    getAndSetAnnouncements() {
      api.get(Paths.ANNOUNCEMENT_URL()).then((response) => {
        this.announcementOptions = response.data.data;
        if (this.announcementOptions.length > 0) {
          this.announcement = this.announcementOptions[0].value;
        }
      });
    },
  },
  mounted() {
    this.getAndSetAnnouncements();
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/variables";

@media print {
  .no-print
  {
    display: none !important;
  }
}

#header-container {
  font-size: 14px;
  height: 72px;
  padding: 0 56px;

  #header-img-container {
    display: table;
    float: left;

    #header-img {
      height: 38px;
      text-align: center;
      vertical-align: middle;
      display: table-cell;
    }
  }

  .header-text {
    font-weight: bold;
    line-height: 19px;
    padding-left: 50px;
  }

  .header-right {
    float: right;

    .login-btn {
      float: right;
      margin: 12px 0 0 24px;
    }

    .el-menu {
      bottom: -6px;
      float: right;

      .el-menu-item {
        line-height: 86px !important;

        &.sm {
          font-size: 12px;
          padding: 0 12px;
        }

        i {
          margin: 0 0 4px 0;
        }

        &.is-active {
          color: $primary-blue !important;
          font-weight: bold;
        }
      }
    }
  }
}

#scrolling-message {
  color: red;
  font-size: 16px;
}
</style>
